/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Embed_AriaInputs */

const en_file_export_audio_embed_aria = /** @type {(inputs: File_Export_Audio_Embed_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed audio description track into broadcast media file`)
};

const fr_file_export_audio_embed_aria = /** @type {(inputs: File_Export_Audio_Embed_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrer la piste de description audio dans le fichier multimédia de diffusion`)
};

const de_file_export_audio_embed_aria = /** @type {(inputs: File_Export_Audio_Embed_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audiobeschreibungsspur in die Sendemediendatei einbetten`)
};

const it_file_export_audio_embed_aria = /** @type {(inputs: File_Export_Audio_Embed_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporare la traccia di descrizione audio nel file multimediale di trasmissione.`)
};

const ru_file_export_audio_embed_aria = /** @type {(inputs: File_Export_Audio_Embed_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встроить аудиодорожку с описанием в медиафайл для трансляции.`)
};

const es_file_export_audio_embed_aria = /** @type {(inputs: File_Export_Audio_Embed_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar pista de audiodescripción en archivo multimedia de difusión`)
};

const zh_cn2_file_export_audio_embed_aria = /** @type {(inputs: File_Export_Audio_Embed_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将音频描述轨道嵌入广播媒体文件中`)
};

const ja_file_export_audio_embed_aria = /** @type {(inputs: File_Export_Audio_Embed_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放送メディアファイルに音声解説トラックを埋め込む`)
};

const hi_file_export_audio_embed_aria = /** @type {(inputs: File_Export_Audio_Embed_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रसारण मीडिया फ़ाइल में ऑडियो विवरण ट्रैक एम्बेड करें`)
};

const pt_pt2_file_export_audio_embed_aria = /** @type {(inputs: File_Export_Audio_Embed_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar faixa de audiodescrição em arquivo de mídia para transmissão`)
};

/**
* | output |
* | --- |
* | "Embed audio description track into broadcast media file" |
*
* @param {File_Export_Audio_Embed_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_embed_aria = /** @type {((inputs?: File_Export_Audio_Embed_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Embed_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_audio_embed_aria(inputs)
	if (locale === "de") return de_file_export_audio_embed_aria(inputs)
	if (locale === "it") return it_file_export_audio_embed_aria(inputs)
	if (locale === "ru") return ru_file_export_audio_embed_aria(inputs)
	if (locale === "es") return es_file_export_audio_embed_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_audio_embed_aria(inputs)
	if (locale === "ja") return ja_file_export_audio_embed_aria(inputs)
	if (locale === "hi") return hi_file_export_audio_embed_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_audio_embed_aria(inputs)
	return en_file_export_audio_embed_aria(inputs)
});